import type { DeepPartial } from '@luna/utils-ts';

import type { Pip } from '../../types/Pip';

export const pipHUFeatureConfig: DeepPartial<Pip> = {
    hideTitleDetailPage: true,
};
